import React from 'react';
import styled from '@emotion/styled';

import artePropTypes from '../../propTypes';
import { mediaQueries, remCalc, font, palette } from '../../css';

const StyledSection = styled('li')(() => ({
    width: '25%',
    [mediaQueries.medium]: {
        margin: remCalc(0, 25),
    },
    [mediaQueries.xlarge]: {
        margin: remCalc(0, 70),
        width: 'auto',
    },
}));

const StyledTitle = styled('div')(({ theme }) => ({
    display: 'flex',
    margin: 0,
    padding: remCalc(0, 10),
    alignItems: 'center',
    lineHeight: font.size.l,
    fontSize: '1.05rem',
    fontWeight: font.weight.medium,
    color: theme.global.textColor,
    [mediaQueries.medium]: {
        padding: 0,
    },
}));

const StyledTitleLink = styled('a')(({ theme }) => ({
    borderBottomColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: remCalc(1),
    margin: 0,
    lineHeight: '1.05rem',
    fontSize: '1.05rem',
    fontWeight: font.weight.medium,
    color: theme.global.textColor,
    ':focus': {
        borderBottomColor: theme.global.textColor,
    },
}));

const StyledList = styled('ul')(() => ({
    margin: 0,
    padding: 0,
    listStyle: 'none',
    lineHeight: 1.6,
}));

const StyledItem = styled('li')(() => ({
    display: 'block',
}));

const StyledLink = styled('a')(({ theme }) => ({
    borderBottomColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: remCalc(1),
    lineHeight: '1.1rem',
    fontSize: '1.1rem',
    fontWeight: font.weight.thin,
    opacity: 0.7,
    color: theme.global.textColor,
    ':hover': {
        opacity: 1,
        color: theme.global.textColor,
    },
    ':focus': {
        opacity: 1,
        color: theme.global.textColor,
        borderBottomColor: theme.global.textColor,
        transition: 'border-bottom-color .3s linear',
    },
}));

export const LinkSection = ({ section }) => (
    <StyledSection>
        {section.href ? (
            <StyledTitleLink href={section.href}>{section.label}</StyledTitleLink>
        ) : (
            <StyledTitle>{section.label}</StyledTitle>
        )}
        {section.links && section.links.length > 0 && (
            <StyledList>
                {section.links.map(link => (
                    <StyledItem key={`${link.label}-${link.href}`}>
                        <StyledLink href={link.href}>{link.label}</StyledLink>
                    </StyledItem>
                ))}
            </StyledList>
        )}
    </StyledSection>
);

LinkSection.propTypes = {
    section: artePropTypes.sectionFooter,
};

export default LinkSection;
